import { Component, Mixins, Prop } from 'vue-property-decorator';
import { UtilMixin } from '../../../UtilMixin';

type LabeledCounts = Array<{ label: string; count: number }>;

@Component({ components: {} })
export default class LoansDistributionPieCard extends Mixins(UtilMixin) {
  @Prop() public tenant?: string;
  @Prop({ default: false }) public plain?: boolean;

  public numberOfCategories = 4;

  public getPieData(counts: LabeledCounts) {
    return {
      labels: counts.map((item) => item.label),
      series: counts.map((item) => ({
        className: `custom-chart-serie-${item.label}`,
        value: item.count,
      })),
    };
  }
}
